import React, { useEffect, useState } from "react";
import api from "../lib/api";

// Drop-in replacement for <img src={fileUrl(path)}>. Fetches the file through
// an authenticated request (Authorization header, not a JWT in the URL) and
// renders it as a local blob URL.
export default function AuthImg({ path, alt = "", className, ...rest }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    if (!path) { setSrc(null); return undefined; }
    let objectUrl;
    let cancelled = false;
    api.get(`/files/${path}`, { responseType: "blob" }).then((r) => {
      if (cancelled) return;
      objectUrl = URL.createObjectURL(r.data);
      setSrc(objectUrl);
    }).catch(() => { if (!cancelled) setSrc(null); });
    return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [path]);

  if (!src) return <div className={className} aria-hidden="true" />;
  return <img src={src} alt={alt} className={className} {...rest} />;
}
